import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Data1jasy19j4j968 as Data } from '../DeletePinMutation.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.z6g_1 = listOf('deletePin');
      }
      o3z(reader, customScalarAdapters) {
        var _deletePin = null;
        $l$loop: while (true) {
          if (reader.g4c(this.z6g_1) === 0)
            _deletePin = get_NullableBooleanAdapter().o3z(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_deletePin);
      }
      a6h(writer, customScalarAdapters, value) {
        writer.r47('deletePin');
        get_NullableBooleanAdapter().t3z(writer, customScalarAdapters, value.j6e_1);
      }
      p3z(writer, customScalarAdapters, value) {
        return this.a6h(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance1vmowywlypwz3,
};
//endregion

//# sourceMappingURL=DeletePinMutation_ResponseAdapter.mjs.map
